module.exports = __webpack_public_path__ + "img/agency-icon.fd1f5716.svg";